// src/pages/DemandPage.js

import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Alert, Table } from 'react-bootstrap';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import api from '../services/api';

export default function DemandPage({ setPage }) {
  const [form, setForm] = useState({
    productId: '',
    storeId: '',
    month: '',
    weekday: '',
    price: '',
    stock: '',
  });
  const [forecast, setForecast] = useState(null);
  const [error, setError] = useState('');
  const [records, setRecords] = useState([]);

  // Load forecast history
  useEffect(() => {
    api
      .get('/demand')
      .then((res) => setRecords(res.data))
      .catch(() => {});
  }, []);

  // Handle form input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle forecast request
  const handleForecast = async () => {
    setError('');
    setForecast(null);
    try {
      const payload = {
        productId: Number(form.productId),
        storeId: Number(form.storeId),
        month: Number(form.month),
        weekday: Number(form.weekday),
        price: Number(form.price),
        stock: Number(form.stock),
      };
      const { data } = await api.post('/demand/forecast', payload);
      setForecast(data.forecast);

      // Add to history
      setRecords((prev) => [
        {
          ...data,
          productId: payload.productId,
          storeId: payload.storeId,
          demand: data.forecast,
          timestamp: new Date().toISOString(),
          _id: Date.now().toString(),
        },
        ...prev,
      ]);
    } catch (err) {
      setError(err.response?.data?.error || 'Forecast failed');
    }
  };

  return (
    <Container className="card-transparent p-4">
      <Header />
      <Navbar setPage={setPage} />

      <h2>Demand Forecasting</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <Form className="row g-2">
        {['productId', 'storeId', 'month', 'weekday', 'price', 'stock'].map((key) => (
          <Form.Group key={key} className="col-md-4">
            <Form.Control
              name={key}
              type={['month', 'weekday', 'price', 'stock'].includes(key) ? 'number' : 'text'}
              placeholder={key}
              value={form[key]}
              onChange={handleChange}
            />
          </Form.Group>
        ))}
        <div className="col-12 text-end">
          <Button onClick={handleForecast} className="mt-2">
            Get Forecast
          </Button>
        </div>
      </Form>

      {forecast !== null && (
        <Alert variant="success" className="mt-3">
          Forecast: <strong>{forecast}</strong>
        </Alert>
      )}

      <h4 className="mt-4">Forecast History</h4>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Product ID</th>
            <th>Store ID</th>
            <th>Forecasted Demand</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {records.map((r) => (
            <tr key={r._id}>
              <td>{r.productId}</td>
              <td>{r.storeId}</td>
              <td>{r.demand ?? r.forecast}</td>
              <td>{new Date(r.timestamp).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}
